<template>
    <div class="lite-button" :class="getHoverClasses">
        <i class="lite-button-icon" :class="iconClass"></i>
        <p class="lite-button-label" v-text="buttonText"></p>
    </div>
</template>

<script>
    export default {
        name: "LiteButton",
        props: {
            text: String,
            hoverColor: String,
            icon: String
        },
        data() {
            return {
                buttonText: this.text,
                buttonHoverColor: this.hoverColor,
                iconClass: this.icon
            }
        },
        computed: {
            getHoverClasses() {
                return this.buttonHoverColor + '-lite-button';
            }
        },
        watch: {
            text(newVal) {
                this.buttonText = newVal;
            },
            hoverColor(newVal) {
                this.buttonHoverColor = newVal;
            },
            icon(newVal) {
                this.iconClass = newVal;
            }
        }
    }
</script>

<style scoped>
    @import '../../../css/shared/button/button.css';
    @import '../../../css/shared/button/button-colors.css';
</style>